import { fromJS } from 'immutable'

import { CHANGE_DRIVER_LIST } from './constants'


export const initialState = fromJS({
  drivers: []
})


export default function reducer(state = initialState, action) {
  switch(action.type){
    case CHANGE_DRIVER_LIST:
      return state.set('drivers', action.drivers)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/reducer.js